var exports = {
  "k": "x61f99309--e19de5--container",
  "x": "x61f99309--e19de5--button",
};

module.exports = exports;
